import React, { useEffect, useState } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import ImagePreloader from "../../ShareElements/ImagePreloader/ImagePreloader";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import CandidatesHead from "./Components/CandidatesHead";
import { Config } from "../../../../../Config";
import axios from "axios";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import MultiSelect from "../../ShareElements/Select/MultiSelect";
import Switch from "../../ShareElements/TextInput/Switch";
import BookmarkIcon from "../../../../../Assets/Images/bookmark.svg";
import CandidateItem from "./Components/CandidateItem";
import Select from "../../ShareElements/Select/Select";
import Collapsible from "react-collapsible";
import { NavLink } from "react-router-dom";
import FormEmptyState from "../../ShareElements/EmptyState/FormEmptyState";
import RangeSlider from "./Components/RangeSlider";
import CompareIcon from "../../../../../Assets/Images/JPA Icons/Compare-white.svg";
import CompareIconActive from "../../../../../Assets/Images/JPA Icons/Compare-active.svg";
import CompareIconInactive from "../../../../../Assets/Images/JPA Icons/Compare-inactive.svg";
import CandidateComparison from "./Components/CandidateComparison/CandidateComparison";
import { formatDate } from "../../../../../Helper_functions";

const ProjectCandidates = (props) => {
  const [CreatedJPA, setCreatedJPA] = useState();
  const [Locations, setLocations] = useState([]);
  const [Langs, setLangs] = useState([]);
  const [YoERange, setYoERange] = useState();
  const [Educations, setEducations] = useState([]);
  const [Skills, setSkills] = useState([]);
  const [Candidates, setCandidates] = useState([]);
  const [SizeOptions] = useState([
    { name: 6, id: 6 },
    { name: 9, id: 9 },
    { name: 12, id: 12 },
  ]);
  const [Pages, setPages] = useState([]);
  const [SelectedSize, setSelectedSize] = useState(6);
  const [PageInfo, setPageInfo] = useState({});
  const [TotalElements, setTotalElements] = useState();
  const [SelectedLocations, setSelectedLocations] = useState([]);
  const [SelectedLangs, setSelectedLangs] = useState([]);
  const [SelectedEducation, setSelectedEducation] = useState([]);
  const [SelectedSkills, setSelectedSkills] = useState([]);
  const [DataIsLoaded, setDataIsLoaded] = useState(false);
  const [MobileFilterIsOpen, setMobileFilterIsOpen] = useState(false);
  const [DesktopFilterIsOpen, setDesktopFilterIsOpen] = useState(false);
  const [SelectedFilterCount, setSelectedFilterCount] = useState(0);
  const [FetchCandidatesCounter, setfetchCounter] = useState(2); // used for creating a loop for fetchCandidates() in case the result was empty (AI has not generated the candidate recoms yet)
  const [CheckedItemIds, setCheckedItemIds] = useState([]);
  const [CompareIsOpen, setCompareIsOpen] = useState(false);
  const [ComparisonData, setComparisonData] = useState([]);
  const [CheckedCandidateIDs, setCheckedCandidateIDs] = useState([]);
  const [NextComparisonData, setNextComparisonData] = useState([]);
  const [FiltersAreShown, setFiltersAreShown] = useState(true);
  const [PreSelectedFilter, setPreSelectedFilter] = useState({});
  const [InitialFilters, setInitialFilters] = useState();
  const [CurrentFilters, setCurrentFilters] = useState();

  useEffect(() => {
    setPreSelectedFilter({
      locations: InitialFilters?.locations ? handlePreSelectedFilters(InitialFilters.locations) : [],
      languages: InitialFilters?.languages ? handlePreSelectedFilters(InitialFilters.languages) : []
    })
  }, [InitialFilters])

  useEffect(() => {
    fetchJPA(true);
    if (
      window.innerWidth > 450 &&
      document.getElementById("nav-/createProjects") !== null
    ) {
      //executed on component mount.
      document
        .getElementById("nav-/createProjects")
        .classList.add("active-node");
      return () => {
        //executed on component unmount.
        document
          .getElementById("nav-/createProjects")
          .classList.remove("active-node");
        // window.localStorage.removeItem("JPAInitialFilters");
      };
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const ignteFectchCandidates = (Initial_Filters) => {
    if (FetchCandidatesCounter > 0) {
      fetchCandidates(true, 0, 6, Initial_Filters);
    }
  };

  const clickActivePage = () => {
    Pages.map((Page) => {
      if (
        document.getElementById(Page + "-page-btn") !== null &&
        document
          .getElementById(Page + "-page-btn")
          .classList.contains("active-page")
      ) {
        document.getElementById(Page + "-page-btn").click();
      }
    });
  };

  const fetchCandidates = (
    IsInitialLoad,
    Start,
    Size,
    Initial_Filters,
    HasNoFilters
  ) => {
    let JPAId = window.localStorage.getItem("CreatedJPAId");
    let Data = {
      start: Start,
      size: Size,
      criteria: {
        nameLike: document.getElementById("search-input")?.value,
        languages: [...SelectedLangs],
        workCities: [...SelectedLocations],
        education: [...SelectedEducation],
        topSkills: [...SelectedSkills],
      },
      sorts: [
        {
          fieldName: "similarity",
          direction: "DESC",
        },
      ],
    };
    if (
      document.getElementById("search-input") &&
      document.getElementById("search-input").value.length === 0
    ) {
      delete Data.criteria.nameLike;
    }

    if (IsInitialLoad) {
      delete Data.criteria.yearsOfExperience;

      // The next condition is only true when the user has clicked on a notification item
      // related to AI_ONLINE_RECOMMENDATION and been redirected to this page, we add
      // the localStorage item as the nameLike search criteria.
      if (window.localStorage.getItem("notif_candidate_name") !== null) {
        Data.criteria.nameLike = window.localStorage.getItem(
          "notif_candidate_name"
        );
        document.getElementById("search-input").value =
          window.localStorage.getItem("notif_candidate_name");
        document.getElementById("search-placeholder").classList.add("hidden");
        document.getElementById("clear-btn").classList.remove("hidden");
        setSelectedFilterCount(1);
      }
    } else {
      Data.criteria.yearsOfExperience = {
        maxValue: parseInt(document.getElementById("yoe-max")?.innerHTML),
        minValue: parseInt(document.getElementById("yoe-min")?.innerHTML),
      };
      if (document.getElementById("search-input")?.value.length > 0) {
        setSelectedFilterCount(1);
      }
    }

    if (SelectedLangs.length === 0) {
      delete Data.criteria.languages;
    }
    if (Initial_Filters && Initial_Filters.languages.length > 0) {
      let Languages = [];
      Initial_Filters.languages.map((Lang) => {
        Languages.push(Lang.id);
      });
      Data.criteria.languages = Languages
      setSelectedLangs(Languages);
    }

    if (!Data.criteria?.yearsOfExperience?.minValue && !Data.criteria?.yearsOfExperience?.maxValue) {
      delete Data.criteria.yearsOfExperience
    }

    if (SelectedLocations.length === 0) {
      delete Data.criteria.workCities;
    }

    if (Initial_Filters && Initial_Filters.locations.length > 0) {
      let Locations = [];
      Initial_Filters.locations.map((Loc) => {
        Locations.push(Loc.name);
      });
      Data.criteria.workCities = Locations
      setSelectedLocations(Locations);
    }
    if (HasNoFilters) {
      delete Data.criteria.workCities;
      delete Data.criteria.languages;
    }

    if (SelectedEducation.length === 0) {
      delete Data.criteria.education;
    }

    if (SelectedSkills.length === 0) {
      delete Data.criteria.topSkills;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/candidates/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.results.length > 0) {
          setfetchCounter(0);
        } else {
          setfetchCounter(FetchCandidatesCounter - 1);
        }
        setCandidates(Res.data.results);
        setTotalElements(Res.data.totalElements);
        if (IsInitialLoad) {
          setDataIsLoaded(true);
          fetchJPA();
        }
        setTimeout(() => {
          if (
            document.getElementById("end") !== null &&
            Res.data.totalElements < SelectedSize
          ) {
            document.getElementById("end").innerHTML = Res.data.totalElements;
          } else if (document.getElementById("end") !== null) {
            // total end item is less than TotalElements
            // or TotalElements is undefined
            if (Start + Size <= TotalElements || !TotalElements) {
              document.getElementById("end").innerHTML = Start + Size;
            } else {
              document.getElementById("end").innerHTML = TotalElements;
            }
          }
        }, 50);
        if (Res.data.results.length === 0) {
          document.getElementById("info-footer").style.display = "none";
        } else {
          if (window.innerWidth > 450) {
            document.getElementById("info-footer").style.display = "flex";
          } else {
            document.getElementById("info-footer").style.display = "grid";
          }
        }
        if (Res.data.results.length > 0) {
          createPagination(Res.data.totalElements);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchBookmarkedCandidates = (IsInitialLoad, Start, Size) => {
    let JPAId = window.localStorage.getItem("CreatedJPAId");
    let Data = {
      start: Start,
      size: Size,
      criteria: {
        nameLike: document.getElementById("search-input")?.value,
        yearsOfExperience: {
          maxValue: parseInt(document.getElementById("yoe-max")?.innerHTML),
          minValue: parseInt(document.getElementById("yoe-min")?.innerHTML),
        },
        languages: [...SelectedLangs],
        workCities: [...SelectedLocations],
        // education: [],
        topSkills: [...SelectedSkills],
      },
    };
    if (document.getElementById("search-input").value.length === 0) {
      delete Data.criteria.nameLike;
    }

    if (IsInitialLoad) {
      delete Data.criteria.yearsOfExperience;
    }

    if (!Data.criteria?.yearsOfExperience.minValue && !Data.criteria?.yearsOfExperience.maxValue) {
      delete Data.criteria.yearsOfExperience
    }

    if (SelectedLangs.length === 0) {
      delete Data.criteria.languages;
    }

    if (SelectedLocations.length === 0) {
      delete Data.criteria.workCities;
    }

    if (SelectedSkills.length === 0) {
      delete Data.criteria.topSkills;
    }

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/candidates/search/bookmark",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCandidates(Res.data.results);
        setTotalElements(Res.data.totalElements);
        setTimeout(() => {
          if (
            document.getElementById("end") !== null &&
            Res.data.totalElements < SelectedSize
          ) {
            document.getElementById("end").innerHTML = Res.data.totalElements;
          } else if (document.getElementById("end") !== null) {
            document.getElementById("end").innerHTML = Start + Size;
          }
        }, 50);
        if (Res.data.results.length === 0) {
          document.getElementById("info-footer").style.display = "none";
        } else {
          if (window.innerWidth > 450) {
            document.getElementById("info-footer").style.display = "flex";
          } else {
            document.getElementById("info-footer").style.display = "grid";
          }
        }
        if (Res.data.results.length > 0) {
          createPagination(Res.data.totalElements);
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const createPagination = (TotalCount) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
    if (PageNum === PageInfo.LastPage) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);
    setTimeout(() => {
      if (
        document.getElementById("saved-switch-holder").classList.length === 2
      ) {
        fetchCandidates(false, NewStart, Size);
      } else {
        fetchBookmarkedCandidates(false, NewStart, Size);
      }
    }, 401);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (parseInt(document.getElementById("end").innerHTML) === TotalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const setSize = () => {
    setCompareIsOpen(false);
    setComparisonData([]);
    setCheckedItemIds([]);

    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    setSelectedSize(SelectedSize);
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };
  const handleOpenFilters = (Action) => {
    if (Action === "close") {
      document
        .getElementById("filters-holder")
        .classList.remove("open-filters-holder");
      document.getElementById("filters-trigger").classList.remove("rotated");
      setDesktopFilterIsOpen(false);
    } else {
      document
        .getElementById("filters-holder")
        .classList.add("open-filters-holder");
      document.getElementById("filters-trigger").classList.add("rotated");
      setDesktopFilterIsOpen(true);
    }
  };

  const fetchJPA = (IsInitial) => {
    let JPAId = window.localStorage.getItem("CreatedJPAId");
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCreatedJPA(Res.data);
        fetchYoE(Res.data.id);
        fetchLocations(
          Res.data.id,
          Res.data.languages,
          Res.data.workCity,
          IsInitial
        );
        fetchLanguages(Res.data.id);
        fetchEducations(Res.data.id);
        fetchSkills(Res.data.id);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // in case IsInitial is true, filtering the non-existant location filters (initial filters) is handled by this function
  const fetchLocations = (JPAId, Languages, WorkCities, IsInitial) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/search/cities",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        let LocationItems = [];
        console.log(Res);
        Res.data.map((Item) => {
          LocationItems.push({
            name: Item,
            id:
              "location-" +
              Item.replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_")
                .replace(" ", "_"),
          });
        });
        setLocations(LocationItems);

        // handling the initial filter (coming from the create JPA forms to this page)
        if (window.localStorage.getItem("JPAInitialFilters")) {
          let Filters = {
            languages: [],
            locations: [],
          };
          Languages.map((Lang) => {
            Filters.languages.push({
              name: Lang.name,
              id: Lang.id,
              type: "language",
            });
          });

          let LocationIds = [];
          LocationItems.map((LocItem) => {
            LocationIds.push(LocItem.id);
          });

          WorkCities.split(",").map((Item) => {
            if (
              LocationIds.indexOf(
                "location-" +
                  Item.replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
              ) !== -1
            ) {
              Filters.locations.push({
                name: Item,
                id:
                  "location-" +
                  Item.replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_")
                    .replace(" ", "_"),
                type: "location",
              });
            }
          });
          setInitialFilters(Filters);
          setCurrentFilters(Filters);
          if (IsInitial) {
            ignteFectchCandidates(Filters);
          }
          // window.localStorage.removeItem("JPAInitialFilters");
        } else {
          setInitialFilters(undefined);
          setCurrentFilters(undefined);
          if (IsInitial) {
            ignteFectchCandidates();
          }
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchLanguages = (JPAId) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/search/languages",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setLangs(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchYoE = (JPAId) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/search/years-of-experience",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setYoERange({
          max: Res.data.maxValue,
          min: Res.data.minValue,
        });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchEducations = (JPAId) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/search/educations",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let EdOptions = [];
        Res.data.map((Item) => {
          EdOptions.push({
            name: Item,
            id: Item + "-ed-item",
          });
        });
        setEducations(EdOptions);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchSkills = (JPAId) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        JPAId +
        "/search/skills",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let SkillItems = [];

        Res.data.map((Item) => {
          SkillItems.push({
            id: Item.id,
            name: Item.title,
          });
        });
        setSkills(SkillItems);

        // hide/unhide filters to update the view and select the new filters
        setFiltersAreShown(false);
        setTimeout(() => {
          setFiltersAreShown(true);
        }, 100);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const saveSelectedLangs = (Selected) => {
    let SelectedLagIds = [];
    Selected.map((Item) => {
      SelectedLagIds.push(Item.id);
    });
    setSelectedLangs(SelectedLagIds);
    setTimeout(() => {
      clickActivePage();
    }, 200);
  };
  const saveSelectedLocations = (Selected) => {
    let SelectedLocs = [];
    Selected.map((Item) => {
      SelectedLocs.push(Item.name);
    });
    setSelectedLocations(SelectedLocs);
    setTimeout(() => {
      clickActivePage();
    }, 200);
  };
  const saveSelectedEducations = (Selected) => {
    console.log(Selected);
    let SelectedEDs = [];
    Selected.map((Item) => {
      SelectedEDs.push(Item.name);
    });
    setSelectedEducation(SelectedEDs);
    setTimeout(() => {
      clickActivePage();
    }, 200);
  };
  const saveSelectedSkills = (Selected) => {
    let SkillsSelected = [];
    Selected.map((Item) => {
      SkillsSelected.push(Item.id);
    });
    setSelectedSkills(SkillsSelected);
    setTimeout(() => {
      clickActivePage();
    }, 200);
  };
  const goBack = () => {
    document.getElementById("back-link").click();
  };
  const handleDesktopFilterChange = (FilterId, Option) => {
    setTimeout(() => {
      let SelectedCount = 0;
      let SearchValue = document.getElementById("search-input")?.value;
      let LangsCount = document
        ?.getElementById("pre-selected-lang-filter")
        ?.innerHTML.replace(/[^0-9]/g, ""); // the replace method with this parameter replaces all non-number characters with "" and gets the count of selected items
      let LocationCount;
      if (document.getElementById("pre-selected-location-filter")) {
        LocationCount = document
          ?.getElementById("pre-selected-location-filter")
          ?.innerHTML.replace(/[^0-9]/g, "");
      } else {
        LocationCount = [];
      }
      let EducationCount = document
        ?.getElementById("pre-selected-ed-filter")
        ?.innerHTML.replace(/[^0-9]/g, "");
      let SkillCount = document
        ?.getElementById("pre-selected-skills-filter")
        ?.innerHTML.replace(/[^0-9]/g, "");

      if (SearchValue?.length > 0) {
        SelectedCount++;
      }
      if (LangsCount?.length !== 0) {
        SelectedCount++;
      }
      if (LocationCount?.length !== 0) {
        SelectedCount++;
      }
      if (EducationCount?.length !== 0) {
        SelectedCount++;
      }
      if (SkillCount?.length !== 0) {
        SelectedCount++;
      }
      setSelectedFilterCount(SelectedCount);
      setTimeout(() => {
        if (document.getElementById("1-page-btn") !== null) {
          clickActivePage();
        } else {
          if (CurrentFilters) {
            fetchCandidates(false, 0, 6, CurrentFilters);
          } else {
            fetchCandidates(false, 0, 6);
          }
        }
      }, 300);
      // handles unchecking an option in the multiselect
      // filters and removes the initial filter chip
      if (FilterId && Option) {
        console.log(FilterId, Option);
        if (
          !document
            .getElementById("icon-" + Option.id)
            ?.classList.contains("feather-check-selected")
        ) {
          if (FilterId === "lang-filter") {
            setCurrentFilters(prevState => {
              const NonSelected = prevState.languages.filter(Item => Item.id !== Option.id)
              return {
                languages: NonSelected,
                locations: [...prevState.locations],
              }
            });
          } else if (FilterId === "location-filter") {
            setCurrentFilters(prevState => {
              const NonSelected = prevState.locations.filter(Item => Item.name !== Option.name)
              return {
                locations: NonSelected,
                languages: [...prevState.languages],
              }
            });
          }
        }
      }
    }, 500);
  };
  const handleMobileFilterChange = () => {
    setTimeout(() => {
      let SelectedCount = 0;
      let LangsCount = document
        .getElementById("pre-selected-lang-filter")
        .innerHTML.replace(/[^0-9]/g, ""); // the replace method with this parameter replaces all non-number characters with "" and gets the count of selected items
      let LocationCount = document
        .getElementById("pre-selected-location-filter")
        .innerHTML.replace(/[^0-9]/g, "");
      let EducationCount = document
        .getElementById("pre-selected-ed-filter")
        .innerHTML.replace(/[^0-9]/g, "");
      let SkillCount = document
        .getElementById("pre-selected-skills-filter")
        .innerHTML.replace(/[^0-9]/g, "");

      if (LangsCount.length !== 0) {
        SelectedCount++;
      }
      if (LocationCount.length !== 0) {
        SelectedCount++;
      }
      if (EducationCount.length !== 0) {
        SelectedCount++;
      }
      if (SkillCount.length !== 0) {
        SelectedCount++;
      }
      setSelectedFilterCount(SelectedCount);
      setTimeout(() => {
        clickActivePage();
      }, 300);
    }, 500);
  };
  const clearDesktopFilters = () => {
    setSelectedLangs([]);
    setSelectedLocations([]);
    setSelectedEducation([]);
    setSelectedSkills([]);
    if (document.getElementById("clear-btn") !== null) {
      document.getElementById("clear-btn").click();
    }
    if (document.getElementById("lang-filter-clear") !== null) {
      document.getElementById("lang-filter-clear").click();
    }
    if (document.getElementById("location-filter-clear") !== null) {
      document.getElementById("location-filter-clear").click();
    }
    if (document.getElementById("ed-filter-clear") !== null) {
      document.getElementById("ed-filter-clear").click();
    }
    if (document.getElementById("skills-filter-clear") !== null) {
      document.getElementById("skills-filter-clear").click();
    }
    setCurrentFilters(undefined);
  };
  const clearMobileFilters = () => {
    setSelectedLangs([]);
    setSelectedLocations([]);
    setSelectedEducation([]);
    setSelectedSkills([]);
    if (document.getElementById("lang-filter-clear") !== null) {
      document.getElementById("lang-filter-clear").click();
    }
    if (document.getElementById("location-filter-clear") !== null) {
      document.getElementById("location-filter-clear").click();
    }
    if (document.getElementById("ed-filter-clear") !== null) {
      document.getElementById("ed-filter-clear").click();
    }
    if (document.getElementById("skills-filter-clear") !== null) {
      document.getElementById("skills-filter-clear").click();
    }
    setCurrentFilters(undefined);
  };
  const displayUpdateDate = () => {
    let DateString = formatDate(
      new Date(CreatedJPA.presetUpdatedTime).getTime()
    );
    let TimeString =
      new Date(CreatedJPA.presetUpdatedTime).getHours() +
      ":" +
      new Date(CreatedJPA.presetUpdatedTime).getMinutes();
    return (
      translateText("last_update_on") + " " + DateString + " at " + TimeString
    );
  };
  const removeInitialFilter = (Filter) => {
    let Filters = {
      languages: [...CurrentFilters.languages],
      locations: [...CurrentFilters.locations],
    };
    let Langs = [];
    let Locs = [];
    if (Filter.type === "language") {
      Filters.languages.map((Lang) => {
        if (Lang.id !== Filter.id) {
          Langs.push(Lang);
        }
        Filters.languages = Langs;
        setSelectedLangs(Langs);
      });
    } else {
      Filters.locations.map((Loc) => {
        if (Loc.id !== Filter.id) {
          Locs.push(Loc);
        }
        Filters.locations = Locs;
        setSelectedLocations(Locs);
      });
    }
    setTimeout(() => {
      setInitialFilters(undefined);
      setCurrentFilters(undefined);

      setTimeout(() => {
        setInitialFilters(Filters);
        setCurrentFilters(Filters);
      }, 50);
    }, 300);
    if (Filters.languages.length === 0 && Filters.locations.length === 0) {
      setSelectedFilterCount(0);
      setSelectedLangs([]);
      setSelectedLocations([]);

      let Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
      fetchCandidates(false, 0, Size, undefined, true);
      window.localStorage.removeItem("JPAInitialFilters");
    }
  };
  const handlePreSelectedFilters = (Array) => {
    let Items = [];
    Array.map((Item) => {
      Items.push({
        name: Item.name,
        id: Item.id
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_")
          .replace(" ", "_"),
      });
    });
    return Items;
  };
  const resetFilters = () => {
    if (window.innerWidth > 450) {
      clearDesktopFilters();
    } else {
      clearMobileFilters();
    }
  };
  const handleClearFilter = (FilterId) => {
    if (FilterId === "location-filter") {
      setSelectedLocations([]);
      setCurrentFilters({
        locations: [],
        languages: [...CurrentFilters.languages],
      });
    } else {
      setSelectedLangs([]);
      setCurrentFilters({
        languages: [],
        locations: [...CurrentFilters.locations],
      });
    }
    setTimeout(() => {
      ignteFectchCandidates();
    }, 500);
  };
  // removes an unchecked candidate id from comparison IDs list
  const removeCandidateId = (Id) => {
    let IDs = [];
    Candidates.map((Item) => {
      if (
        document
          .getElementById(Item.candidate.id + "-checkbox")
          .classList.contains("icon-checkbox-active")
      ) {
        IDs.push(Item.candidate.id);
      }
    });
    let Checked = IDs.filter((Item) => {
      return Item !== Id;
    });
    setCheckedItemIds(Checked);
  };
  // adds a checked candidate id to comparison IDs list
  const addCandidateId = (Id) => {
    let IDs = [];
    Candidates.map((Item) => {
      if (
        document
          .getElementById(Item.candidate.id + "-checkbox")
          .classList.contains("icon-checkbox-active")
      ) {
        IDs.push(Item.candidate.id);
      }
    });
    let Checked = IDs.filter((Item) => {
      return Item !== Id;
    });
    Checked.push(Id);
    setCheckedItemIds(Checked);
  };
  const toggleCompare = (SortCategory, Direction) => {
    let URL =
      Config.ProjectServiceURL +
      "/api/project/preset/" +
      CreatedJPA.id +
      "/candidates/compare?sortDirection=" +
      Direction +
      "&sortBy=" +
      SortCategory;

    let Req = {
      method: "POST",
      baseURL: window._env_.API_URL + URL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: CheckedItemIds,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setComparisonData([]);
        setCheckedCandidateIDs([]);
        setComparisonData(Res.data);
        if (!CompareIsOpen) {
          setCompareIsOpen(true);
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const updateCheckedCandidates = (Selected) => {
    console.log(Selected);
    let IDs = [];
    ComparisonData.map((Item) => {
      IDs.push(Item.presetId);
    });

    let ActiveIDs = [];
    IDs.map((Id) => {
      if (document.getElementById("checkbox-" + Id).checked) {
        ActiveIDs.push(Id);
      }
    });
    setCheckedCandidateIDs(ActiveIDs);

    let SelectedCandidatesList = [];
    ComparisonData.map((Item) => {
      if (ActiveIDs.indexOf(Item.presetId) !== -1) {
        SelectedCandidatesList.push(Item);
      }
    });

    let Remaining = ComparisonData.filter((Row) => {
      return SelectedCandidatesList.indexOf(Row) === -1;
    });
    setNextComparisonData(Remaining);
  };
  const removeCheckedRows = () => {
    setComparisonData([]);
    setCompareIsOpen(true);

    let IDs = [];
    ComparisonData.map((Item) => {
      IDs.push(Item.presetId);
    });

    let ActiveIDs = [];
    IDs.map((Id) => {
      if (document.getElementById("checkbox-" + Id).checked) {
        ActiveIDs.push(Id);
      }
    });
    let SelectedCandidatesList = [];
    ComparisonData.map((Item) => {
      if (ActiveIDs.indexOf(Item.presetId) !== -1) {
        SelectedCandidatesList.push(Item);
      }
    });
    let Remaining = NextComparisonData.filter((Row) => {
      return SelectedCandidatesList.indexOf(Row) === -1;
    });
    let RemainingCheckedIDs = [];
    Remaining.map((Item) => {
      RemainingCheckedIDs.push(Item.candidate.id);
    });
    setCheckedItemIds(RemainingCheckedIDs);

    setTimeout(() => {
      setComparisonData(NextComparisonData);
    }, 250);
    setCheckedCandidateIDs([]);
  };
  return (
    <div className="main-content jpa-candidates">
      <NavLink to="/createProjects" hidden id="back-link"></NavLink>
      <ImagePreloader
        Images={[CompareIcon, CompareIconActive, CompareIconInactive]}
      />
      <ContentHeader
        LangData={props.LangData}
        PageName={translateText("projects")}
      />
      <div className="content-header">
        <div className="address">
          <p>{translateText("projects")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("create_projects")}</p>
          <img src={Circle} alt="." />
          <p>{translateText("candidates")}</p>
        </div>
      </div>
      {CompareIsOpen ? (
        <CandidateComparison
          Close={() => {
            setCompareIsOpen(false);
            setComparisonData([]);
            setCheckedItemIds([]);
            fetchCandidates(true, 0, 6);
          }}
          GoBack={() => goBack()}
          JPA={CreatedJPA}
          Data={ComparisonData}
          LangData={props.LangData}
          FetchData={(SortCategory, Direction) =>
            toggleCompare(SortCategory, Direction)
          }
          Type="project"
          CheckedCandidateIDs={CheckedCandidateIDs}
          UpdateCheckedCandidates={(Selected) =>
            updateCheckedCandidates(Selected)
          }
          RemoveCheckedRows={() => removeCheckedRows()}
        />
      ) : (
        <>
          <div className="candidates-head">
            {CreatedJPA === undefined ? null : (
              <CandidatesHead
                JPA={CreatedJPA}
                IsProject
                UpdateJPA={() => fetchJPA()}
                UpdateCandidates={() => clickActivePage()}
                GoBack={() => goBack()}
                LangData={props.LangData}
              />
            )}
            {window.innerWidth <= 450 ? (
              <React.Fragment>
                <SearchInput
                  OnChange={() => clickActivePage()}
                  Placeholder={translateText(
                    "search_candidate_input_placeholder"
                  )}
                />

                <div
                  className={
                    MobileFilterIsOpen ? "mobile-filters-overlay" : "hidden"
                  }
                >
                  <section className="mobile-filters-header">
                    <i
                      className="feather-x"
                      onClick={() => setMobileFilterIsOpen(false)}
                    ></i>
                    <h1>{translateText("filters")}</h1>
                    <p onClick={() => clearMobileFilters()}>
                      {translateText("clear")}
                    </p>
                  </section>
                  {FiltersAreShown ? (
                    <section className="mobile-filters-body">
                      {YoERange === undefined ? null : (
                        <RangeSlider
                          MaxValue={YoERange.max}
                          MinValue={YoERange.min}
                          UpdateCandidates={() => clickActivePage()}
                        />
                      )}
                      <div className="filter-row-item">
                        <p className="row-label">{translateText("language")}</p>
                        {CurrentFilters ? (
                          <>
                            {Langs.length > 0 ? (
                              <MultiSelect
                                Options={Langs}
                                Id="lang-filter"
                                IsWithId
                                Name="Language(s)"
                                ChangeHandler={(Option) =>
                                  handleDesktopFilterChange(
                                    "lang-filter",
                                    Option
                                  )
                                }
                                SaveSelectedOptions={(Selected) =>
                                  saveSelectedLangs(Selected)
                                }
                                ClearAction={() =>
                                  handleClearFilter("lang-filter")
                                }
                                PreSelectedItems={PreSelectedFilter.languages}
                              />
                            ) : null}
                          </>
                        ) : (
                          <MultiSelect
                            Options={Langs}
                            Id="lang-filter"
                            IsWithId
                            Name="Language(s)"
                            ChangeHandler={() => handleDesktopFilterChange()}
                            SaveSelectedOptions={(Selected) =>
                              saveSelectedLangs(Selected)
                            }
                            ClearAction={() => setSelectedLangs([])}
                          />
                        )}
                      </div>
                      <div className="filter-row-item">
                        <p className="row-label">{translateText("location")}</p>
                        {CurrentFilters ? (
                          <>
                            {Locations.length > 0 ? (
                              <MultiSelect
                                Options={Locations}
                                IsWithId
                                Id="location-filter"
                                Name="Location"
                                ChangeHandler={(Option) =>
                                  handleDesktopFilterChange(
                                    "location-filter",
                                    Option
                                  )
                                }
                                SaveSelectedOptions={(Selected) =>
                                  saveSelectedLocations(Selected)
                                }
                                ClearAction={() =>
                                  handleClearFilter("location-filter")
                                }
                                PreSelectedItems={PreSelectedFilter.locations}
                              />
                            ) : null}
                          </>
                        ) : (
                          <MultiSelect
                            Options={Langs}
                            Id="lang-filter"
                            IsWithId
                            Name="Language(s)"
                            ChangeHandler={() => handleMobileFilterChange()}
                            SaveSelectedOptions={(Selected) =>
                              saveSelectedLangs(Selected)
                            }
                          />
                        )}
                      </div>
                      <div className="filter-row-item">
                        <p className="row-label">{translateText("skills")}</p>
                        <MultiSelect
                          Options={Skills}
                          IsWithId
                          Id="skills-filter"
                          Name="Skills"
                          ChangeHandler={() => handleMobileFilterChange()}
                          SaveSelectedOptions={(Selected) =>
                            saveSelectedSkills(Selected)
                          }
                        />
                      </div>
                      <div className="filter-row-item">
                        <p className="row-label">
                          {translateText("education")}
                        </p>
                        <MultiSelect
                          Options={Educations}
                          IsWithId
                          Id="ed-filter"
                          Name="Education"
                          ChangeHandler={() => handleMobileFilterChange()}
                          SaveSelectedOptions={(Selected) =>
                            saveSelectedEducations(Selected)
                          }
                        />
                      </div>
                    </section>
                  ) : null}
                  <section className="mobile-filters-footer">
                    <span
                      className="filter-action"
                      onClick={() => setMobileFilterIsOpen(false)}
                    >
                      {translateText("apply_filters")}
                    </span>
                  </section>
                </div>
              </React.Fragment>
            ) : null}
            <div id="filters-holder" className="filters-holder">
              {!DesktopFilterIsOpen && SelectedFilterCount > 0 ? (
                <span className="selected-filter-count is-desktop">
                  <p className="count-label">
                    {"(" + SelectedFilterCount + " Active)"}
                  </p>
                  <p
                    className="borderless-btn"
                    onClick={() => clearDesktopFilters()}
                  >
                    {translateText("clear")}
                  </p>
                </span>
              ) : null}
              <Collapsible
                onOpen={() => handleOpenFilters("open")}
                onClosing={() => handleOpenFilters("close")}
                transitionTime={200}
                trigger={
                  <section className="header-toggle">
                    <h1 className="filters-title">
                      {translateText("filters")}
                    </h1>
                    <button id="filters-trigger">
                      <i className="feather-chevron-down"></i>
                    </button>
                  </section>
                }
              >
                <React.Fragment>
                  <div className="filler"></div>
                  {FiltersAreShown ? (
                    <section className="header-filters">
                      {window.innerWidth > 450 ? (
                        <React.Fragment>
                          <SearchInput
                            OnChange={() => handleDesktopFilterChange()}
                            Placeholder={translateText(
                              "search_candidate_input_placeholder"
                            )}
                          />
                          {CurrentFilters ? (
                            <>
                              {Langs.length > 0 ? (
                                <MultiSelect
                                  Options={Langs}
                                  Id="lang-filter"
                                  IsWithId
                                  Name="Language(s)"
                                  ChangeHandler={(Option) =>
                                    handleDesktopFilterChange(
                                      "lang-filter",
                                      Option
                                    )
                                  }
                                  SaveSelectedOptions={(Selected) =>
                                    saveSelectedLangs(Selected)
                                  }
                                  ClearAction={() =>
                                    handleClearFilter("lang-filter")
                                  }
                                  PreSelectedItems={PreSelectedFilter.languages}
                                />
                              ) : null}
                            </>
                          ) : (
                            <MultiSelect
                              Options={Langs}
                              Id="lang-filter"
                              IsWithId
                              Name="Language(s)"
                              ChangeHandler={() => handleDesktopFilterChange()}
                              SaveSelectedOptions={(Selected) =>
                                saveSelectedLangs(Selected)
                              }
                              ClearAction={() => setSelectedLangs([])}
                            />
                          )}
                          {CurrentFilters ? (
                            <>
                              {Locations.length > 0 ? (
                                <MultiSelect
                                  Options={Locations}
                                  IsWithId
                                  Id="location-filter"
                                  Name="Location"
                                  ChangeHandler={(Option) =>
                                    handleDesktopFilterChange(
                                      "location-filter",
                                      Option
                                    )
                                  }
                                  SaveSelectedOptions={(Selected) =>
                                    saveSelectedLocations(Selected)
                                  }
                                  ClearAction={() =>
                                    handleClearFilter("location-filter")
                                  }
                                  PreSelectedItems={PreSelectedFilter.locations}
                                />
                              ) : null}
                            </>
                          ) : (
                            <MultiSelect
                              Options={Locations}
                              IsWithId
                              Id="location-filter"
                              Name="Location"
                              ChangeHandler={() => handleDesktopFilterChange()}
                              SaveSelectedOptions={(Selected) =>
                                saveSelectedLocations(Selected)
                              }
                              ClearAction={() => setSelectedLocations([])}
                            />
                          )}
                          {YoERange === undefined ? null : (
                            <RangeSlider
                              MaxValue={YoERange.max}
                              MinValue={YoERange.min}
                              UpdateCandidates={() =>
                                handleDesktopFilterChange()
                              }
                            />
                          )}
                          <MultiSelect
                            Options={Educations}
                            IsWithId
                            Id="ed-filter"
                            Name="Education"
                            ChangeHandler={() => handleDesktopFilterChange()}
                            ClearAction={() => setSelectedEducation([])}
                            SaveSelectedOptions={(Selected) =>
                              saveSelectedEducations(Selected)
                            }
                          />
                          <MultiSelect
                            Options={Skills}
                            IsWithId
                            Id="skills-filter"
                            Name="Skills"
                            ChangeHandler={() => handleDesktopFilterChange()}
                            ClearAction={() => setSelectedSkills([])}
                            SaveSelectedOptions={(Selected) =>
                              saveSelectedSkills(Selected)
                            }
                          />
                        </React.Fragment>
                      ) : null}
                    </section>
                  ) : null}
                </React.Fragment>
              </Collapsible>
            </div>
            {CurrentFilters ? (
              <div className="initial-filters">
                {CurrentFilters.locations
                  .concat(CurrentFilters.languages)
                  .map((Filter) => (
                    <span className="initial-filter-chip">
                      <i
                        className="feather-x"
                        onClick={() => removeInitialFilter(Filter)}
                      ></i>
                      {Filter.name}
                    </span>
                  ))}
              </div>
            ) : null}
            <div className="content-head-wrapper">
              {CreatedJPA === undefined ||
              CreatedJPA.presetUpdatedTime === null ||
              CreatedJPA.presetUpdatedTime === undefined ? null : (
                <p className="last-update"> {displayUpdateDate()}</p>
              )}
              <div className="saved-only" id="saved-only">
                <span
                  className={
                    CheckedItemIds.length < 2
                      ? "compare-btn compare-btn-disabled"
                      : "compare-btn"
                  }
                  onClick={() => toggleCompare("candidate.firstName", "ASC")}
                >
                  <img alt="" src={CompareIcon} />
                  {translateText("compare")}
                </span>
                <img alt="" src={BookmarkIcon} />
                <p className="saved-label">
                  {translateText("saved_items_only")}
                </p>
                <Switch ChangeEvent={() => clickActivePage()} Id="saved" />
                <section
                  className="mobile-filters-toggle is-mobile"
                  onClick={() => setMobileFilterIsOpen(true)}
                >
                  <i className="feather-filter"></i>
                  <p className="mobile-filters-label">
                    {translateText("filters")}
                    {SelectedFilterCount > 0 ? (
                      <p className="active-filter-count">
                        {" (" + SelectedFilterCount + " active)"}
                      </p>
                    ) : null}
                  </p>
                </section>
              </div>
            </div>
          </div>
          {Candidates.length === 0 ? (
            <React.Fragment>
              {DataIsLoaded ? (
                <FormEmptyState
                  StateName={"candidates"}
                  Message={
                    "There are no candidates that match the selected filter(s)."
                  }
                  LangData={props.LangData}
                  ResetFilters={() => resetFilters()}
                />
              ) : null}
            </React.Fragment>
          ) : (
            <div className="candidates-wrapper">
              {Candidates.map((Candidate) => (
                <CandidateItem
                  Data={Candidate}
                  JPA={CreatedJPA}
                  Id={Candidate.id}
                  IsProject
                  RefreshData={(id, isBookmarked) => {
                    clickActivePage();
                    props.RefreshChatbotCandidateBookmark(id, isBookmarked);
                  }}
                  LangData={props.LangData}
                  RemoveCandidateId={(Id) => removeCandidateId(Id)}
                  AddCandidateId={(Id) => addCandidateId(Id)}
                  TotalCheckedCount={CheckedItemIds.length}
                />
              ))}
            </div>
          )}
          <div className="info-footer jpa-details-footer" id="info-footer">
            <div className="pagenumber-summary">
              {translateText("showing")} <p id="start">1</p>
              {translateText("to")} <p id="end">6</p>
              {translateText("of")} {TotalElements} {translateText("items")}.
            </div>
            <section className="pagination-holder">
              <button
                onClick={() => requestPrevPage()}
                id="prev-page"
                className={
                  Pages.length < 6
                    ? "page-btn page-btn-disabled right-margined"
                    : "page-btn page-btn-disabled"
                }
              >
                <i className="feather-chevron-left"></i>
              </button>
              <React.Fragment>
                {Pages.length < 6 ? (
                  <React.Fragment>
                    {Pages.map((Page) => (
                      <React.Fragment>
                        {Page === 1 ? (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn active-page"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        ) : (
                          <button
                            key={Page}
                            onClick={() => requestPageNumber(Page)}
                            className="page-btn"
                            id={Page + "-page-btn"}
                          >
                            {Page}
                          </button>
                        )}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <button
                      onClick={() => requestPageNumber(1)}
                      className="page-btn active-page"
                      id={1 + "-page-btn"}
                    >
                      {1}
                    </button>
                    {PageInfo.FirstDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() =>
                        requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                      }
                      className="page-btn"
                      id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                    >
                      {parseInt(PageInfo.MiddlePage - 1)}
                    </button>
                    {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                      <button
                        onClick={() => requestPageNumber(PageInfo.MiddlePage)}
                        className="page-btn"
                        id={PageInfo.MiddlePage + "-page-btn"}
                      >
                        {PageInfo.MiddlePage}
                      </button>
                    )}
                    {parseInt(PageInfo.MiddlePage + 1) >=
                    PageInfo.LastPage ? null : (
                      <button
                        onClick={() =>
                          requestPageNumber(parseInt(PageInfo.MiddlePage + 1))
                        }
                        className="page-btn "
                        id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                      >
                        {parseInt(PageInfo.MiddlePage + 1)}
                      </button>
                    )}
                    {!PageInfo.LastDotsShown ? <p>...</p> : null}
                    <button
                      onClick={() => requestPageNumber(PageInfo.LastPage)}
                      className="page-btn"
                      id={PageInfo.LastPage + "-page-btn"}
                    >
                      {PageInfo.LastPage}
                    </button>
                  </React.Fragment>
                )}
              </React.Fragment>
              <button
                onClick={() => requestNextPage()}
                id="next-page"
                className={
                  Pages.length < 6 ? "page-btn left-margined" : "page-btn"
                }
              >
                <i className="feather-chevron-right"></i>
              </button>
            </section>
            <div className="row-count-select">
              <p className="row-info">{translateText("items_per_page")}</p>
              <Select
                Initial={"6"}
                Options={SizeOptions}
                IsWithId
                Id={"row-per-page"}
                PreSelectedId="6"
                ChangeHandler={() =>
                  setTimeout(() => {
                    setSize();
                  }, 100)
                }
                ValidationError=""
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectCandidates;
